/* eslint-disable no-console */

// How long since the person last touched this tab. One set of passive
// listeners for the whole app; consumers (lib/adaptivePoll.js) read `idleMs()`
// and may subscribe to `onActivity` (throttled to once a second). Returning
// to the tab (focus / visibility) counts as activity too.

const ACTIVITY_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'wheel', 'mousemove', 'scroll']
const NOTIFY_THROTTLE_MS = 1000

let lastActivityAt = Date.now()
let lastNotifyAt = 0
const listeners = new Set()

function mark () {
  lastActivityAt = Date.now()
  if (lastActivityAt - lastNotifyAt < NOTIFY_THROTTLE_MS) return
  lastNotifyAt = lastActivityAt
  for (const fn of listeners) {
    try { fn() } catch (e) { console.log(e) }
  }
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  for (const ev of ACTIVITY_EVENTS) window.addEventListener(ev, mark, { passive: true, capture: true })
  window.addEventListener('focus', mark)
  document.addEventListener('visibilitychange', () => { if (!document.hidden) mark() })
}

/** Milliseconds since the last user interaction with this tab. */
export function idleMs () {
  return Date.now() - lastActivityAt
}

/** Subscribe to (throttled) activity; returns an unsubscribe function. */
export function onActivity (fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
